
import * as Ably from 'ably';
import flatPicker from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Table, TableColumn, Select, Button, Option } from 'element-ui';
import DriversModal from './components/DriversModal.vue';
import ExportAllOrderNoti from './components/exportOrderAllNoti.vue';

import LogisticsModal from './components/LogisticsModal.vue';
import AssignModal from './components/assignModal.vue';
import ButtonAssign from './components/ButtonAssign.vue';
import AcceptButton from './components/AcceptButton.vue';

import OrderStatus from './components/OrderStatus.vue';
import OrderReceipt from './components/OrderReceipt.vue';
import buttonAssignLogistics from './components/buttonAssignLogistics.vue';
import buttonAssignDriver from './components/buttonAssignDriver.vue';
import {
  Order as OrderApi,
  Integrations,
  Order,
  Location as LocationApi,
  Employee,
  Connect as ConnectService,
  Device as DeviceService,
} from '@/services/SOLO';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { ValidationObserver, configure } from 'vee-validate';
import { Component, Prop, Vue, Watch, Emit, Ref } from 'vue-property-decorator';
import { Driver, DriverAttributes, Location, Logistics } from '@/models';
import moment from 'moment';
import 'moment/locale/pt-br';
import { eventHandler, translations } from '@/mixins';
import { mapGetters } from 'vuex';
import sound from '../../../../../public/sound/default_notif.wav';
import { BButton } from 'bootstrap-vue';
import Translations from './components/Translations.vue';
import Card from '@/components/Cards/Card.vue';
import { truncate } from '@/util/truncate';
import CountdownTimer from './components/CountdownTimer.vue';
import CursorPagination from '@/components/CursorPagination.vue';

interface Filter {
  order: string;
  from: string;
  to: string;
  customer: string;
  email: string;
  mobile: string;
  location: any;
  status: string;
  statusGroup?: string;
  today: boolean;
  type: string;
  'exclude-statuses'?: string;
  source: string;
  'payment-type': string;
  'device-id': string[];
}

@Component({
  components: {
    RouteBreadCrumb,
    buttonAssignDriver,
    DriversModal,
    AssignModal,
    ButtonAssign,
    AcceptButton,
    ExportAllOrderNoti,
    buttonAssignLogistics,
    LogisticsModal,
    OrderStatus,
    OrderReceipt,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    flatPicker,
    Card,
    CountdownTimer,
    CursorPagination,
  },
  computed: {
    ...mapGetters({
      activeConcept: 'account/activeConcept',
      userRole: 'account/getUserRole',
      user: 'account/getUser',
      getLocale: 'app/getLocale',
    }),
  },
  filters: {
    datetime (value: any, format = 'YYYY-MM-DD HH:mm') {
      return moment.utc(value).locale('en-us').fromNow();
    },
    datetime1 (value: any, format = 'YYYY-MM-DD HH:mm') {
      return moment.utc(value).locale('ar-sa').fromNow();
    },
    circleColor (finishedTime: any, promisedTime: any) {
      const start = finishedTime
        ? moment.utc(finishedTime).local()
        : moment().utc().local();
      const end = moment.utc(promisedTime);
      const diff = moment.duration(start.diff(end)).asMinutes();
      if (diff > 2) {
        // console.log('text-danger');
        return 'text-danger';
      } else if (diff > 0) {
        // console.log('text-warning');
        return 'text-warning';
      } else {
        // console.log('text-success');
        return 'text-success';
      }
    },
    formatDate (date: string) {
      return moment
        .utc(date, 'YYYY-MM-D hh:mm:ss')
        .locale('en-us')
        .local()
        .format('MMM D YYYY HH:mm');
    },
  },
  mixins: [eventHandler, translations],
})
export default class Orders extends Vue {
  toggleView = false;
  activeConcept: any;
  userRole: any;
  user: any;
  canPlayNotificationSound = false;
  driverOpen = false;
  assignOpen = false;
  exportOrderNotiOpen = false;
  logisticsOpen = false;
  page = 1;
  size = 7;
  source = 'Source';
  posTooltip = '';
  paymentMethod = 'Payment';
  type = 'Type';
  orders: any = [];
  maxOrders: any = [];
  filteredOrders: any = [];
  driverData: Record<string, any> = {};
  logisticData: Record<string, any> = {};
  logistics: Array<Logistics> = [];
  statuses: Array<Record<string, any>> = [];
  storeLocations: Array<Record<string, any>> = [];
  isLoading = false;
  loaded = false;
  visible = false;
  filter: Filter = {
    order: '',
    from: '',
    to: '',
    customer: '',
    email: '',
    mobile: '',
    location: [],
    status: '',
    statusGroup: 'all',
    today: true,
    type: '',
    source: '',
    'payment-type': '',
    'device-id': [],
  };

  erpDate = '';
  flag = true;
  perPage = 50;
  nextCursor: any = null;
  prevCursor: any = null;
  eventTab: any = '';
  confirm!: Function;
  // broadcasted!: Function
  broadcastedSoloOrder!: Function;
  broadcastedSoloOrderNonAdmin!: Function;
  broadcastedSoloOrderStatus!: Function;
  broadcastedDriverAssign!: Function;
  broadcastedOrderAssign!: Function;
  $notify: any;
  $notifications: any;
  getLocale: any;
  notif!: Function;
  public translate!: Function;
  $refs!: {
    sound: HTMLAudioElement;
    playNewOrderAudio: any;
  };

  isVisible = false;
  locationIds = '';
  employeeLocations: any = [];
  aggregators: any[] = [];
  isPlay = false;
  isMobile = false;
  webNotif: any;
  // ablyUnsubscribe: any;
  ablyUnsubscribeSoloOrder: any;
  ablyUnsubscribeSoloOrderStatus: any;
  ablyUnsubscribeDriverAssign: any;
  ablyUnsubscribeOrderAssign: any;
  screenSize = 0;
  trunc: Function = truncate;
  audio: any;
  notificationType = '';
  driverName = '';
  orderIncludes: Array<Record<string, any>> = [];
  sources: Array<Record<string, any>> = [
    {
      value: 'iOs',
      text: 'iOS',
    },
    {
      value: 'Android',
      text: 'Android',
    },
    {
      value: 'Web',
      text: 'Web',
    },
    {
      value: 'Kiosk',
      text: 'Kiosk',
    },
    {
      value: 'Call Center',
      text: 'Call Center',
    },
  ];

  paymentMethods: Array<Record<string, any>> = [
    {
      value: '',
      text: 'All',
    },
    {
      value: 'cash',
      text: 'Cash',
    },
    {
      value: 'card',
      text: 'Card',
    },
    {
      value: 'payment-decline',
      text: 'Payment Decline',
    },
  ];

  private locations: Array<Record<string, any>> = [];
  tab = 1;
  orderType = 'open';
  countAbly = 0;
  kioskDevices: any;
  kioskDevice: any;

  @Watch('canPlayNotificationSound', { deep: true })
  onCanPlaySoundChanged (val: any) {
    window.localStorage.setItem('sound', val);
    if (val) {
      console.log('val: ', val);
      // if (!this.isPlay) {
      //   let audio = document.getElementsByTagName("audio")[0];
      //   audio.play().then(() => {
      //   }).catch((e) => {
      //   });
      //   this.isPlay = true;
      // }
    }
  }

  private get isMobileDevice (): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  }

  private get isTabletDevice (): boolean {
    return /Android|webOS|iPad|iPod|BlackBerry|Opera Mini/i.test(
      navigator.userAgent,
    );
  }

  get dropDownText (): string {
    if (this.tab === 1) {
      return this.translate('Active');
    } else {
      return this.translate('Close');
    }
  }

  mounted () {
    // this.getEmployeeLocations();
    this.getDevices();
    this.erpDate = new Date().toJSON().slice(0, 10).replace(/-/g, '-');
    console.log('erpDate', this.erpDate);

    this.getLocations(1);

    this.audio = document.getElementsByTagName('audio')[0];

    if (!('Notification' in window)) {
      console.error('This browser does not support desktop notification');
    } else if (
      Notification.permission === 'default' ||
      Notification.permission === 'denied'
    ) {
      Notification.requestPermission();
    }

    window.addEventListener('resize', this.screensizeHandler);

    if (this.isMobileDevice) {
      this.isMobile = true;

      const h = this.$createElement;
      // More complex structure
      const titleVNode = h('div', {
        domProps: {
          innerHTML: '<div style="direction: rtl !important">انتباه!<div>',
        },
      });
      const msgVNode = h('div', {
        domProps: {
          innerHTML:
            '<p style="direction: rtl !important; text-align: center !important">هل تريد تشغيل صوت عند تلقي طلب جديد؟<p>',
        },
      });
      const yesVNode = h('p', {
        domProps: {
          innerHTML:
            '<p style="direction: rtl !important; height: 6px !important">نعم!<p>',
        },
      });
      const noVNode = h('p', {
        domProps: {
          innerHTML:
            '<p style="direction: rtl !important; height: 6px !important">لا!<p>',
        },
      });

      if (this.getLocale === 'ar_SA') {
        this.confirm(this.$bvModal, msgVNode, {
          title: titleVNode,
          okTitle: yesVNode,
          cancelTitle: noVNode,
        }).then(async (value: boolean) => {
          this.canPlayNotificationSound = value;
          this.initAudio();
        });
      } else {
        this.confirm(
          this.$bvModal,
          'Do you want to play a sound when an order is received?',
          {
            title: 'Attention!',
            okTitle: 'YES',
            cancelTitle: 'NO',
          },
        ).then(async (value: boolean) => {
          this.canPlayNotificationSound = value;
          this.initAudio();
        });
      }
    } else {
      console.log('local storage:', window.localStorage.getItem('sound'));
      if (window.localStorage.getItem('sound') === 'true') {
        let hasClickedOnce = false;
        document.onclick = () => {
          console.log('trigger click event');
          if (!hasClickedOnce) {
            hasClickedOnce = true;
            this.initAudio();
          }
        };

        this.canPlayNotificationSound = true;
      }
    }

    this.getStoreLocations()
      .then(() => {
        this.getLogisticPartners();
        if (this.userRole.includes('administrator')) {
          this.pushedNotification();
        } else {
          this.locations.forEach((element) => {
            /* @ts-ignore */
            this.pushedNotification(element.id);
          });
        }
        return this.getOrderStatuses();
      })
      .then(() => {
        this.getOrders(this.orderType);
      });

    // this.getAggregators();
  }

  get eventDropDownText (): string {
    if (this.eventTab === 1) {
      return this.translate('Orders');
    } else {
      return this.translate('Events');
    }
  }

  viewCashier (evnt: boolean) {
    this.toggleView = evnt;
  }

  viewAdmin (evnt: boolean) {
    this.toggleView = evnt;
  }

  cancelOrder (orderId: any) {
    const payload = {
      'order-status': 'cancelled-by-employee',
    };
    OrderApi.updateStatus(payload, orderId)
      .then((response: any) => {
        this.$notify({
          title: 'STATUS CHANGED!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: 'Status have been successfully changed',
          type: 'success',
          icon: 'fas fa-check',
        });
        location.reload();
      })
      .catch((err: any) => {
        const message =
          JSON.parse(err?.response?.data?.messages)?.errors?.status[0] ||
          JSON.parse(err?.response?.data?.messages)?.message ||
          'Something went wrong, please try again!';
        // console.log('err:' , JSON.parse(err?.response?.data?.messages));
        // this.description = this.orderStatusCode;
        this.$notify({
          title: 'SYSTEM ERROR!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message,
          type: 'danger',
          icon: 'fas fa-bomb',
        });
      });
  }

  updateStatusChange (orderId: any) {
    const payload = {
      'order-status': 'ready',
    };
    OrderApi.updateStatus(payload, orderId)
      .then((response: any) => {
        this.$notify({
          title: 'STATUS CHANGED!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: 'Status have been successfully changed',
          type: 'success',
          icon: 'fas fa-check',
        });
        location.reload();
      })
      .catch((err: any) => {
        const message =
          JSON.parse(err?.response?.data?.messages)?.errors?.status[0] ||
          JSON.parse(err?.response?.data?.messages)?.message ||
          'Something went wrong, please try again!';
        // console.log('err:' , JSON.parse(err?.response?.data?.messages));
        // this.description = this.orderStatusCode;
        this.$notify({
          title: 'SYSTEM ERROR!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message,
          type: 'danger',
          icon: 'fas fa-bomb',
        });
      });
  }

  initAudio (): void {
    this.audio.muted = true;
    this.audio.play();
    setTimeout(() => {
      this.audio.pause();
      this.audio.currentTime = 0;
    }, 200);
  }

  testtest () {
    alert('asdasd');
  }

  destroyed () {
    if (this.webNotif) {
      this.webNotif.close();
      this.webNotif = null;
    }
    if (this.ablyUnsubscribeSoloOrder) {
      this.ablyUnsubscribeSoloOrder.unsubscribe();
      this.ablyUnsubscribeSoloOrder = null;
    }
    if (this.ablyUnsubscribeSoloOrderStatus) {
      this.ablyUnsubscribeSoloOrderStatus.unsubscribe();
      this.ablyUnsubscribeSoloOrderStatus = null;
    }
    if (this.ablyUnsubscribeDriverAssign) {
      this.ablyUnsubscribeDriverAssign.unsubscribe();
      this.ablyUnsubscribeDriverAssign = null;
    }
    if (this.ablyUnsubscribeOrderAssign) {
      this.ablyUnsubscribeOrderAssign.unsubscribe();
      this.ablyUnsubscribeOrderAssign = null;
    }
    window.removeEventListener('resize', this.screensizeHandler);
  }

  screensizeHandler () {
    this.screenSize = screen.width;

    if (this.isMobileDevice) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.$forceUpdate();
  }

  disabled (check: any) {
    if (check === true) {
      return 'pointer-events: none';
    }
    return 'pointer-events: auto';
  }

  getLocations (page: any) {
    const lang = 'en-us';
    LocationApi.fetchLocations(lang, page)
      .then((response: any) => {
        if (response?.data?.data && Array.isArray(response?.data?.data)) {
          this.locations = [...this.locations, ...response?.data?.data];
        }

        if (
          response.data.meta.pagination.current_page <
          response.data.meta.pagination.total_pages
        ) {
          this.getLocations(response.data.meta.pagination.current_page + 1);
        }
        console.log('total loc', this.locations);
        this.$forceUpdate();
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  async getEmployeeLocations () {
    if (!this.employeeLocations.length) {
      return Employee.find(this.user.id).then((response) => {
        if (response.data.included) {
          this.employeeLocations = response.data.included;

          console.log('employee location', this.employeeLocations);
        }
      });
    }
    return Promise.resolve();
  }

  getFirstName (customerName: string) {
    return customerName || 'N/A';
  }

  closeOrder () {
    this.flag = true;
    this.visible = true;
  }

  openOrder () {
    this.flag = true;
  }

  circleTooltip (finishedTime: any, promisedTime: any) {
    const start = finishedTime
      ? moment.utc(finishedTime).local()
      : moment().utc().local();
    const end = moment.utc(promisedTime);
    const diff = moment.duration(start.diff(end)).asMinutes();
    if (diff > 2) {
      return 'Past the promised time';
    } else if (diff > 0) {
      return 'Slightly past the promised time';
    } else {
      if (!finishedTime) {
        return 'Not finished';
      } else {
        return 'Finished on time';
      }
    }
  }

  posColor (code: number, posResponse: any) {
    if (code && posResponse) {
      this.posTooltip = 'Order successfully sent to POS';
      return 'success';
    } else if (!code && posResponse) {
      this.posTooltip = 'Order failed in POS';
      return 'danger';
    } else {
      this.posTooltip = '';
      return 'secondary';
    }
  }

  tooltip (code: number, posResponse: any) {
    if (code && posResponse) {
      return 'Order successfully sent to POS';
    } else if (!code && posResponse) {
      return 'Order failed in POS';
    } else {
      return '';
    }
  }

  paginate (cursor: any) {
    this.getOrders(this.orderType, cursor);
  }

  resetForm (reset: any) {
    this.filter.order = '';
    this.filter.from = '';
    this.filter.to = '';
    this.filter.customer = '';
    this.filter.email = '';
    this.filter.mobile = '';
    this.filter.location = [];
    this.filter.status = '';
    this.filter.today = true;
    this.filter.type = '';
    this.filter.source = '';
    this.filter['payment-type'] = '';
    this.filter['device-id'] = [];
    this.erpDate = new Date().toJSON().slice(0, 10).replace(/-/g, '-');
  }

  async filterLiveOrder (order: any) {
    const filter = { ...this.filter };
    let tmpFilterLocation: any = [];

    if (!filter.location.length && this.userRole === 'supervisor') {
      filter.location = this.storeLocations.map((s: any) => s.id).join();
    } else {
      tmpFilterLocation = [...filter.location];
      filter.location = filter.location.join();
    }

    if (Array.isArray(filter['device-id']) && filter['device-id'].length > 0) {
      if (!filter['device-id'].includes(order['device-id'])) {
        console.log(
          'Filtered out',
          'kioskDeviceId',
          filter['device-id'],
          order['device-id'],
        );
      }
    }

    const exclude = 'initiated,waiting-for-payment';
    if (filter.statusGroup === 'unpaid') {
      const statuses = this.statuses
        .filter((status: any) => !exclude.includes(status.attributes?.code))
        .map((status: any) => status.attributes?.code)
        .join();
      delete filter.statusGroup;
      filter['exclude-statuses'] = statuses;
    } else if (filter.statusGroup === 'paid') {
      const statuses = this.statuses
        .filter((status: any) => exclude.includes(status.attributes?.code))
        .map((status: any) => status.attributes?.code)
        .join();
      delete filter.statusGroup;
      filter['exclude-statuses'] = statuses;
    } else if (filter.statusGroup === 'all') {
      delete filter['exclude-statuses'];
      delete filter.statusGroup;
    }

    let toBeAdded = true;

    if (
      filter.customer &&
      (filter.customer != order['customer-id'] ||
        filter.customer != order['customer-name'])
    ) {
      console.log(
        'toBeAdded',
        'customer',
        filter.customer,
        order['customer-id'],
      );
      toBeAdded = false;
    }
    // if (filter.email && (filter.email != order['customer-email'])) {
    //   toBeAdded = false;
    // }
    if (filter.location && !filter.location.includes(order['location-id'])) {
      console.log(
        'toBeAdded',
        'location',
        filter.location,
        order['location-id'],
      );
      toBeAdded = false;
    }
    if (filter.mobile && filter.mobile != order.mobile) {
      console.log('toBeAdded', 'mobile', filter.mobile, order.mobile);
      toBeAdded = false;
    }
    if (filter.order) {
      console.log('toBeAdded', 'order', filter.order);
      toBeAdded = false;
    }
    if (filter.source.length && !filter.source.includes(order.source)) {
      console.log('toBeAdded', 'source', filter.source, order.source);
      toBeAdded = false;
    }
    if (filter.status.length && !filter.status.includes(order.status)) {
      console.log('toBeAdded', 'status', filter.status, order.status);
      toBeAdded = false;
    }
    if (!filter.today) {
      console.log('toBeAdded', 'today', filter.today);
      const from = new Date(this.filter.from);
      const to = new Date(this.filter.to);
      const orderUpdatedAt = new Date(order['updated-at']);

      if (
        from.getTime() < orderUpdatedAt.getTime() &&
        to.getTime() > orderUpdatedAt.getTime()
      ) {
        toBeAdded = true;
      } else {
        toBeAdded = false;
      }

      if (!this.filter.from || !this.filter.to) {
        toBeAdded = true;
      }
    }
    if (filter.type.length && !filter.type.includes(order.type)) {
      console.log('toBeAdded', 'type', filter.type, order.type);
      toBeAdded = false;
    }
    if (
      filter['payment-type'].length &&
      !filter['payment-type'].includes(order['payment-method'])
    ) {
      console.log(
        'toBeAdded',
        'payment-type',
        filter['payment-type'],
        order['payment-method'],
      );
      toBeAdded = false;
    }
    if (this.tab == 3) {
      console.log(
        'toBeAdded',
        'delayed orders are not consider as live orders',
      );
      toBeAdded = false;
    }
    let liveOrderType = '';
    if (order['current-status'].type == 'open') {
      liveOrderType = order['current-status'].type;
    } else {
      liveOrderType = 'closed';
    }
    if (!this.orderType.includes(liveOrderType)) {
      console.log('toBeAdded', 'orderType', this.orderType, liveOrderType);

      const toBeClose =
        'finished,cancelled-by-customer,cancelled-by-employee,order-failed';

      if (toBeClose.includes(order['current-status'].code)) {
        toBeAdded = true;
      } else {
        toBeAdded = false;
      }
    }

    console.log('toBeAdded', toBeAdded);

    return toBeAdded;
  }

  async pushedNotification (branchId = '') {
    if (this.userRole.includes('administrator')) {
      this.ablyUnsubscribeSoloOrder = await this.broadcastedSoloOrder(
        this.activeConcept.id,
      );
    } else {
      this.ablyUnsubscribeSoloOrder = await this.broadcastedSoloOrderNonAdmin(
        this.activeConcept.id,
        branchId,
      );
    }

    await this.ablyUnsubscribeSoloOrder.subscribe(async (payload: any) => {
      const isAdmin = this.userRole.includes('administrator');
      const order = payload?.data?.order;
      console.log('broadcasting new solo order: ', payload);

      if (!(await this.filterLiveOrder(order))) {
        // exclusive for unconfirmed card payment orders
        if (
          order['payment-method'] == 'card' &&
          order.status == 'waiting-for-payment'
        ) {
          /**
           * UPDATE ORDER STATUS
           */
          this.ablyUnsubscribeSoloOrderStatus =
            await this.broadcastedSoloOrderStatus(
              this.activeConcept.id,
              order.id,
            );
          await this.ablyUnsubscribeSoloOrderStatus.subscribe(
            async (payload2: any) => {
              const isAdmin2 = this.userRole.includes('administrator');
              const order2 = payload2?.data?.order;
              console.log('broadcasting update solo order status: ', payload2);

              if (!(await this.filterLiveOrder(order2))) {
                return;
              }

              this.notificationType = 'solo-order-status';
              await this.getEmployeeLocations().then(async () => {
                const found2 = this.employeeLocations.find(
                  (loc: any) =>
                    Number(loc.id) ===
                    Number(payload2?.data?.order?.['location-id']),
                );
                if (isAdmin2 || found2) {
                  await this.findOrder(order2);
                }
              });
            },
          );
        }
        return;
      }

      /**
       * UPDATE ORDER STATUS
       */
      this.ablyUnsubscribeSoloOrderStatus =
        await this.broadcastedSoloOrderStatus(this.activeConcept.id, order.id);
      await this.ablyUnsubscribeSoloOrderStatus.subscribe(
        async (payload2: any) => {
          const isAdmin2 = this.userRole.includes('administrator');
          const order2 = payload2?.data?.order;
          console.log('broadcasting update solo order status: ', payload2);

          if (!(await this.filterLiveOrder(order2))) {
            return;
          }

          this.notificationType = 'solo-order-status';
          await this.getEmployeeLocations().then(async () => {
            const found2 = this.employeeLocations.find(
              (loc: any) =>
                Number(loc.id) ===
                Number(payload2?.data?.order?.['location-id']),
            );
            if (isAdmin2 || found2) {
              await this.findOrder(order2);
            }
          });
        },
      );

      /**
       * UPDATE ORDER ASSIGN
       */
      this.ablyUnsubscribeOrderAssign = await this.broadcastedOrderAssign(
        this.activeConcept.id,
        order.id,
      );
      await this.ablyUnsubscribeOrderAssign.subscribe(async (payload2: any) => {
        const isAdmin2 = this.userRole.includes('administrator');
        const order2 = payload2?.data?.order;
        console.log('broadcasting update solo order assign: ', payload2);

        this.notificationType = 'solo-order-assign';
        await this.getEmployeeLocations().then(async () => {
          const found2 = this.employeeLocations.find(
            (loc: any) =>
              Number(loc.id) === Number(payload2?.data?.order?.['location-id']),
          );
          if (isAdmin2 || found2) {
            await this.findOrder(order2);
          }
        });
      });

      this.notificationType = 'solo-order';
      const exclude = 'initiated,waiting-for-payment';

      const paymentMethod = 'cash,card-on-pickup,card-on-delivery';
      if (
        !exclude.includes(payload?.data?.order?.status) ||
        paymentMethod.includes(payload?.data?.order?.['payment-method'])
      ) {
        if (payload?.data?.order?.['payment-method'] !== 'cash') {
          if (
            payload?.data?.order?.['payment-method'] === 'card-on-pickup' ||
            payload?.data?.order?.['payment-method'] === 'card-on-delivery'
          ) {
            await this.getEmployeeLocations().then(async () => {
              const found = this.employeeLocations.find(
                (loc: any) =>
                  Number(loc.id) ===
                  Number(payload?.data?.order?.['location-id']),
              );
              if (isAdmin || found) {
                await this.findOrder(order);
              }
            });
          } else {
            await this.getEmployeeLocations().then(async () => {
              const found = this.employeeLocations.find(
                (loc: any) =>
                  Number(loc.id) ===
                  Number(payload?.data?.order?.['location-id']),
              );
              if (isAdmin || found) {
                await this.findOrder(order);
              }
            });
          }
        } else {
          await this.getEmployeeLocations().then(async () => {
            const found = this.employeeLocations.find(
              (loc: any) =>
                Number(loc.id) === Number(payload?.data?.order?.['location-id']),
            );
            if (isAdmin || found) {
              await this.findOrder(order);
            }
          });
        }
      }
    });
  }

  DriverModalOpenState (open = true) {
    this.driverOpen = open;
  }

  ExportOrderAllNotiModalOpenState (open = true) {
    this.exportOrderNotiOpen = open;
  }

  LogisticsModalOpenState (open = true) {
    this.logisticsOpen = open;
  }

  AssignModalOpenState (open = true) {
    this.assignOpen = open;
  }

  showDriver (data: Record<string, any>) {
    this.driverData = data;
    this.DriverModalOpenState(true);
  }

  showAssign (data: Record<string, any>, data1: Record<string, any>, dName: any) {
    this.driverData = data;
    this.logisticData = data1;
    this.driverName = dName;
    this.AssignModalOpenState(true);
  }

  showLogistics (data: Record<string, any>) {
    this.logisticData = data;
    this.LogisticsModalOpenState(true);
  }

  get orderItems () {
    if (this.orderIncludes.length) {
      return this.orderIncludes.filter((include: any) => {
        return include.type === 'order-item';
      });
    }

    return [];
  }

  get modifiers () {
    if (this.orderIncludes.length) {
      return this.orderIncludes.filter((include: any) => {
        return include.type === 'modifier';
      });
    }
    return [];
  }

  get ingredients () {
    if (this.orderIncludes.length) {
      return this.orderIncludes.filter((include: any) => {
        return include.type === 'item-ingredient';
      });
    }

    return [];
  }

  getItemModifier (data: Array<any>, modifiers: Array<any>) {
    return data.map((d: any) => {
      const filtered: any = modifiers.filter((modifier: any) => {
        return modifier.id === d.id;
      });
      if (filtered.length) {
        console.log('getItemModifier: ', d, filtered[0]);
        return filtered[0];
      }
      return null;
    });
  }

  changeOrderDisplay (orderType: string, tab: any) {
    this.getOrders(orderType);
    this.tab = tab;
  }

  getOrders (orderType: string, cursor: any = null) {
    this.orderType = orderType;
    const filter = { ...this.filter };
    let tmpFilterLocation: any = [];
    this.orders = [];
    this.isLoading = true;
    this.loaded = false;

    if (!filter.location.length && this.userRole === 'supervisor') {
      filter.location = this.storeLocations.map((s: any) => s.id).join();
    } else {
      tmpFilterLocation = [...filter.location];
      filter.location = filter.location.join();
    }

    const exclude = 'initiated,waiting-for-payment';
    if (filter.statusGroup === 'unpaid') {
      const statuses = this.statuses
        .filter((status: any) => !exclude.includes(status.attributes?.code))
        .map((status: any) => status.attributes?.code)
        .join();
      delete filter.statusGroup;
      filter['exclude-statuses'] = statuses;
    } else if (filter.statusGroup === 'paid') {
      const statuses = this.statuses
        .filter((status: any) => exclude.includes(status.attributes?.code))
        .map((status: any) => status.attributes?.code)
        .join();
      delete filter.statusGroup;
      filter['exclude-statuses'] = statuses;
    } else if (filter.statusGroup === 'all') {
      delete filter['exclude-statuses'];
      delete filter.statusGroup;
    }
    /* @ts-ignore */
    const copyFilter = _.cloneDeep(filter);
    copyFilter.status = filter.status.concat(this.orderType);

    OrderApi.all(cursor, this.size, copyFilter).then((response) => {
      this.filter.location = [...tmpFilterLocation];
      this.isLoading = false;
      this.loaded = true;

      this.nextCursor = response.data.meta.pagination?.next_cursor;
      this.prevCursor = response.data.meta.pagination?.prev_cursor;
      this.perPage = response.data.meta.pagination.per_page;
      this.orders = response.data.data;
      if (this.tab == 3) {
        this.orders.forEach((order: any) => {
          const end = order.attributes['finished-at']
            ? moment.utc(order.attributes['finished-at']).local()
            : moment().utc().local();
          const start = moment.utc(order.attributes['promised-time']);

          const duration = moment.duration(start.diff(end));

          if (duration.asMinutes() <= 3) {
            order.is_delayed = true;
          }
        });

        this.orders = this.orders.filter((order: any) => {
          return order.is_delayed;
        });
      }

      this.orderIncludes = response.data.included;

      if (this.isMobile) {
        const promiseArray: any = [];
        this.orders.forEach((order: any) => {
          promiseArray.push(OrderApi.findItems(order?.id));
        });
        Promise.all(promiseArray).then((responses: any) => {
          this.orders.map((data: any, key: any) => {
            let items = responses?.[key].data?.data;
            const included = responses?.[key].data?.included;
            items = items.map((item: any) => {
              if (item?.relationships?.modifiers?.data) {
                item.relationships.modifiers.data =
                  item?.relationships?.modifiers?.data.map((mod: any) =>
                    included.find((inc: any) => inc.id === mod.id)
                  );
              }
              return item;
            });
            data.attributes['show-receipt'] = true;
            data.attributes['order-items'] = items;
            this.$forceUpdate();
          });
        });
      }

      this.getOrderStatuses();
    });

    this.screenSize = screen.width;

    this.isVisible = false;
  }

  getOrderDetails (data: Array<any>, orderItems: Array<any>) {
    return data.map((d: any) => {
      const filtered: any = orderItems.filter((orderItem: any) => {
        return orderItem.id === d.id;
      });
      if (filtered.length) {
        console.log('getOrderItem: ', d, filtered[0]);
        return filtered[0];
      }
      return null;
    });
  }

  getStoreLocations () {
    return LocationApi.fetchLocations().then(
      (response: any) => (this.storeLocations = response.data.data),
    );
  }

  playNotificationSound () {
    const audio = document.getElementsByTagName('audio')[0];
    audio.muted = false;
    if (this.canPlayNotificationSound) {
      audio
        .play()
        .then(() => {})
        .catch((e) => {});
    }
  }

  async findOrder (order: any) {
    if (!this.filter.type.length || this.filter.type.includes(order.type)) {
      if (this.notificationType == 'solo-order') {
        await OrderApi.find(order.id).then((response: any) => {
          const res = response.data.data;
          res.live = true;
          this.updateOrders(res);
        });
      } else if (
        this.notificationType == 'solo-order-status' ||
        this.notificationType == 'solo-order-assign'
      ) {
        order.live = true;
        const data = {
          id: order.id,
          attributes: order,
        };
        this.updateOrders(data);
      }
    }
  }

  async refreshStatus (data: any) {
    await OrderApi.getOrderStatusSync(data).then((response: any) => {
      const item = response.data.data;
      console.log(item);
      this.orders.some((v: any, i: any) => {
        if (item.id === v.id) {
          this.orders[i].attributes['current-status'].description =
            item.attributes?.code;
          return true;
        }
      });
    });
  }

  notify (title: string, message: string, order: any) {
    if (!this.isMobile) {
      this.webNotif = new Notification(title, {
        body: message,
      });
      this.webNotif.onclick = () => {
        this.webNotif = null;
        this.$router.push({ name: 'order-details', params: { id: order.id } });
      };
    } else {
      const config: any = { body: message };
      navigator.serviceWorker.register('/sw.js');
      navigator.serviceWorker.ready.then(function (registration) {
        config.data = order.id;
        registration.showNotification(title, config);
      });
    }
  }

  showNotification (title: string, message: string, order: any) {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        this.notify(title, message, order);
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            this.notify(title, message, order);
          }
        });
      }
    }
  }

  async updateOrder (data: any) {
    const { id, attributes } = data;
    const sr = this.translate('SAR');
    // const old = !!this.orders.find((ord: any) => Number(ord.id) === Number(id));
    const title = 'New order';
    const message = `New order #${id} for ${sr} ${attributes.total} at ${attributes['location-name']}.`;
    const findOrderIdx = this.orders.findIndex(
      (ord: any) => Number(ord.id) === Number(id),
    );

    // Play sound and notification
    if (this.notificationType == 'solo-order') {
      if (
        this.userRole.includes('restaurant') &&
        data.attributes.status == 'waiting-for-payment'
      ) {
      } // skip sound and notification for this condition
      else {
        this.playNotificationSound();
        this.showNotification(title, message, data);
      }
    } else if (this.notificationType == 'solo-order-status') {
      if (
        data.attributes['payment-method'] == 'card' &&
        data.attributes.status == 'posted'
      ) {
        this.playNotificationSound();
        this.showNotification(title, message, data);
      }
    }

    if (findOrderIdx > -1) {
      this.orders[findOrderIdx] = data;
      this.$forceUpdate();
    } else {
      if (this.isMobile) {
        OrderApi.findItems(id).then((response) => {
          let items = response.data?.data;
          const included = response.data?.included;
          items = items.map((item: any) => {
            if (item?.relationships?.modifiers?.data) {
              item.relationships.modifiers.data =
                item?.relationships?.modifiers?.data.map((mod: any) =>
                  included.find((inc: any) => inc.id === mod.id)
                );
            }
            return item;
          });
          data.attributes['show-receipt'] = true;
          data.attributes['order-items'] = items;
          // this.orders.unshift(data);
          if (this.notificationType == 'solo-order') {
            if (
              this.userRole.includes('restaurant') &&
              data.attributes.status == 'waiting-for-payment'
            ) {
            } // don't update orders list for this condition
            else {
              this.orders.unshift(data);
            }
          } else if (this.notificationType == 'solo-order-status') {
            if (
              data.attributes['payment-method'] == 'card' &&
              data.attributes.status == 'posted'
            ) {
              this.orders.unshift(data);
            }
          }
        });
      } else {
        if (this.notificationType == 'solo-order') {
          if (
            this.userRole.includes('restaurant') &&
            data.attributes.status == 'waiting-for-payment'
          ) {
          } // don't update orders list for this condition
          else {
            this.orders.unshift(data);
          }
        } else if (this.notificationType == 'solo-order-status') {
          if (
            data.attributes['payment-method'] == 'card' &&
            data.attributes.status == 'posted'
          ) {
            this.orders.unshift(data);
          }
        }
      }
    }
  }

  async getDevices (filters: any = {}) {
    try {
      // Convert arrays into the correct query format
      const formattedFilters = { ...filters };

      if (
        Array.isArray(filters['device-id']) &&
        filters['device-id'].length > 0
      ) {
        formattedFilters['device-id'] = `[${filters['device-id'].join(',')}]`; // Convert to backend format
      }

      const response = await DeviceService.all(1, 9999, formattedFilters);
      console.log('Kiosk Devices Response:', response);

      if (response.data && response.data.data) {
        this.kioskDevices = response.data.data.map(
          (device: { id: string; attributes: { label: string } }) => ({
            id: device.id,
            label: device.attributes.label,
          }),
        );
        console.log('Mapped Kiosk Devices:', this.kioskDevices);
      } else {
        console.warn('No devices found in response');
      }
    } catch (error) {
      console.error('Error fetching kiosk devices:', error);
    }
  }

  async updateOrders (data: any) {
    const isAdmin = this.userRole.includes('administrator');
    // GET employee locations
    // if already exist do not call API for performance
    await this.getEmployeeLocations().then(() => {
      const found = this.employeeLocations.find(
        (loc: any) => Number(loc.id) === Number(data.attributes['location-id']),
      );
      if (isAdmin || found) {
        this.updateOrder(data);
      }
    });
  }

  updateOrderIndex (data: any) {
    this.orders[data.index] = data.data;
  }

  iconSrc (src: string) {
    return `/img/order icons/${src.toLowerCase()}.png`;
  }

  getLogisticPartners () {
    Integrations.logisticsPartners('food-logistics').then(
      (response) => (this.logistics = response.data.data),
    );
  }

  getOrderStatuses () {
    return OrderApi.statusList().then(
      (response: any) => (this.statuses = response.data.data),
    );
  }

  getActiveOrderStatuses () {
    return OrderApi.activeStatusList().then(
      (response: any) => (this.statuses = response.data.data),
    );
  }

  exportOrder (orderId: any) {
    if (true) {
      this.$notify({
        title: 'PLEASE WAIT!',
        horizontalAlign: 'right',
        message: 'Please wait, the file will be downloaded in few seconds.',
        type: 'info',
        icon: 'fas fa-spinner fa-spin',
      });
      OrderApi.exportOrder(orderId).then((response) => {
        window.open(response.data.data.attributes['csv-uri'], '_blank');
      });
    }
  }

  exportAllOrder () {
    const filter = { ...this.filter };

    delete filter.statusGroup;

    if (!filter.today) {
      const hasFromDate = filter.from?.trim();
      const hasToDate = filter.to?.trim();

      // Ensure from and to filters are used together
      if ((hasFromDate && !hasToDate) || (!hasFromDate && hasToDate)) {
        this.$notify({
          title: this.translate('Error'),
          message: this.translate(
            'Both "From" and "To" dates must be provided together or both left empty.',
          ),
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
        });
        return;
      }

      if (hasFromDate && hasToDate) {
        // If both dates provided, validate 40-day limit
        const fromDate = moment(filter.from);
        const toDate = moment(filter.to);

        // Validate date order
        if (fromDate.isAfter(toDate)) {
          this.$notify({
            title: this.translate('Error'),
            message: this.translate('"From" date cannot be after "To" date.'),
            type: 'danger',
            icon: 'fas fa-exclamation-triangle',
          });
          return;
        }

        // Validate 40-day limit
        const daysDifference = toDate.diff(fromDate, 'days');
        if (daysDifference > 40) {
          this.$notify({
            title: this.translate('Error'),
            message: this.translate(
              'Date range cannot exceed 40 days. Please select a shorter range.',
            ),
            type: 'danger',
            icon: 'fas fa-exclamation-triangle',
          });
          return;
        }
      }
      if (!hasFromDate && !hasToDate) {
        // TODO: this will be changed accordingly whether display error or set 40 day range when both dates are not provided. for now displaying error.

        // If both dates are empty, set them to 40 days ago
        // filter.to = moment().add(40, 'days').format('YYYY-MM-DD');
        // filter.from = moment().format('YYYY-MM-DD');

        this.$notify({
          title: this.translate('Error'),
          message: this.translate(
            'Please select a date range. "From" and "To" dates cannot be empty.',
          ),
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
        });
        return;
      }
    } else {
      const today = moment().format('YYYY-MM-DD');
      filter.from = today;
      filter.to = today;
    }

    this.$notify({
      title: 'PLEASE WAIT!',
      horizontalAlign: 'right',
      message: 'Please wait, the file will be exported in few seconds.',
      type: 'info',
      icon: 'fas fa-spinner fa-spin',
    });
    OrderApi.exportAllOrder(filter)
      .then((response) => {
        // window.open(response.data.data.attributes['csv-uri'], '_blank');
        this.ExportOrderAllNotiModalOpenState();
      })
      .catch((error) => {
        this.$notifications.clearAll();
        this.$notify({
          title: 'ERROR!',
          horizontalAlign: 'right',
          message:
            error.response.data.message ||
            error.response.data.error?.[0]?.detail,
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
        });
      });
  }

  exportERP () {
    if (true) {
      this.$notify({
        title: 'PLEASE WAIT!',
        horizontalAlign: 'right',
        message: 'Please wait, the file will be exported in few seconds.',
        type: 'success',
        icon: 'fas fa-spinner fa-spin',
      });
      OrderApi.exportERP(this.erpDate)
        .then((response) => {
          window.open(response.data.url, '_blank');
        })
        .catch((err) => {
          this.$notify({
            title: 'Export Error!',
            verticalAlign: 'bottom',
            horizontalAlign: 'left',
            message: 'Something went wrong.',
            type: 'danger',
            icon: 'fas fa-bomb',
          });
        });
    }
  }

  NewExportOrderAllNoti (open: any) {
    this.exportOrderNotiOpen = open;
  }

  closeExportOrderAllNotiSet (close: any) {
    this.exportOrderNotiOpen = close;
  }

  filterActiveDrivers (drivers: any) {
    // console.log('filterActiveDrivers: ', drivers);
    // console.log('filterActiveDrivers - filtered: ', drivers && drivers.filter((driver: any) => (driver.attributes.status === 'active')));
    return (
      drivers &&
      drivers.filter((driver: any) => driver.attributes.status === 'active')
    );
  }

  onStatusGroupClick (type: string) {
    this.filter.statusGroup = type;
    this.getOrders(this.orderType);
  }

  truncateCode (code: string) {
    if (code.length <= 8) {
      return code;
    }

    return (
      code.substring(0, 4) +
      '...' +
      code.substring(code.length - 4, code.length)
    );
  }
}
